import { render, staticRenderFns } from "./marketer-list.vue?vue&type=template&id=1b0854e0&scoped=true"
import script from "./marketer-list.vue?vue&type=script&lang=js"
export * from "./marketer-list.vue?vue&type=script&lang=js"
import style0 from "./marketer-list.vue?vue&type=style&index=0&id=1b0854e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0854e0",
  null
  
)

export default component.exports